<script setup>
import { useMainStore } from '@/store'
import { computed } from 'vue'
import { addLateDeliverySurcharge } from '@/utils/helper'

const store = useMainStore()
// passed properties
const props = defineProps({
  configuration: {
    type: Object,
    required: true
  },
})

const inEnglish = computed(() => store.inEnglish)

const shoppingCart = computed(() => store.settings.shopping_cart)

const printArticle = computed(() => {
  const index = shoppingCart.value.print_items.findIndex((article) => {
    return article.booth_refinement_id === props.configuration.booth_refinement.id
  })

  if (index > -1) {
    return shoppingCart.value.print_items[index]
  }
  return null
})

const hasImage = computed(() => {
  if (printArticle.value === null || printArticle.value.images === null) {
    return false
  }

  return printArticle.value.images.length > 0
})

const previewImage = computed(() => {
  if (!hasImage.value) {
    return ARTICLE_DEFAULT_IMAGE
  }

  return '/images/articles/' + printArticle.value.images[0].path;
})

const displayName = computed(() => {
  if (printArticle.value === null) {
    return '';
  }
  
  return (inEnglish.value) ? printArticle.value.name_en : printArticle.value.name
})

const displayDescription = computed(() => {
  if (printArticle.value === null) {
    return '';
  }
  
  return (inEnglish.value) ? printArticle.value.description_en : printArticle.value.description
})

// computed properties
const earlyBirdMode = computed(() => store.tmp.early_bird_mode)
const lateDelivery = computed(() => store.tmp.late_delivery)

const price = computed(() => {
  return (earlyBirdMode.value)
    ? addLateDeliverySurcharge(printArticle.value.exhibitionPrices.price_net, lateDelivery.value)
    : printArticle.value.exhibitionPrices.price_net
})

// methods
const deleteFromBasket = () => {
  shoppingCart.value.removeBoothConfiguration(props.configuration.id)
  shoppingCart.value.removeBoothRefinementArticle(props.configuration.booth_refinement.id)
}
</script>

<template>
  <div class="article-inner-frame">
    <div class="article-thumb article-img-slider col-xs-4">
      <div v-if="hasImage" class="article-img-frame" style="width: 100%;">
        <img :src="previewImage" alt="" class="pc-print__image">
      </div>
      <div class="article-img-frame" v-else></div>
    </div>
    <div class="article-info col-xs-8">
      <span class="article-label">{{ displayName }}</span>
      <article class="article-description">{{ displayDescription }}</article>
      <div class="action-row row">
        <span class="article-price col-xs-5">
          {{ $filters.formatMoney(price) }}
          <small class="article-unit" :class="printArticle.unit">
            <span v-if="printArticle.unit === 'sqm'" class="square_m">
              /m<sup>2</sup>
            </span>
            <span v-else-if="printArticle.unit === 'pc'" class="per_unit">
              {{ $t("booth_articles.per_unit") }}
            </span>
          </small>
          <small v-if="printArticle.inclusive">
            ({{ printArticle.inclusive}} {{ $t('labels.inclusive_abbreviation') }})
          </small>
        </span>
      </div>
      <div v-if="configuration.label">
        <strong>{{ $t('labels.booth_label') }}: </strong><br/>
        <span>{{ configuration.label }}</span>
      </div>
      <div class="action-row row">
        <span class="text-primary text-right pull-right cursor--pointer" @click="deleteFromBasket">
          <i class="fa fa-trash"></i> {{ $t('configurator.buttons.delete') }}
        </span>
      </div>
    </div>
  </div>
</template>